module.exports = "<footer class=\"main-footer\">\r\n  <div class=\"pull-right hidden-xs\">\r\n    <b>Version</b> 2.3.11\r\n  </div>\r\n  <strong>Copyright &copy; 2014-2016 <a href=\"http://almsaeedstudio.com\">Almsaeed Studio</a>.</strong> All rights reserved.\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/projects/angular/DineroAgil/src/app/admin/admin-footer/admin-footer.component.html
// module id = ../../../../../src/app/admin/admin-footer/admin-footer.component.html
// module chunks = main